module.exports = __webpack_public_path__ + "static/media/wings.8b5815f9.svg";